export enum BannerPosition {
    // DESKTOP BANNER POSITIONS
    A = 30,
    M = 50,
    M2= 51,
    PREROLL = 11,
    POSTROLL = 13,
    R_PORTRAIT = 79, // MRON - M Run On Network
    TAKEOVER = 70,
    BELOW_ARTICLE = 67,
    BILLBOARD = 52,
    FOOTER = 69,

    // MOBILE BANNER POSITIONS
    MOBILE_M = 95,
    MOBILE_M2 = 96,
    MOBILE_M3 = 97,
    MOBILE_PREROLL = 91,
    MOBILE_POSTROLL = 93,
    MOBILE_FULLSCREEN_468x468 = 94,
}

export const preOrPostRolls = [
    BannerPosition.PREROLL,
    BannerPosition.POSTROLL,
    BannerPosition.MOBILE_PREROLL,
    BannerPosition.MOBILE_PREROLL
];